import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'config/authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export { default as HttpClient } from './HttpClient';
export { default as TokenCredential } from './TokenCredential';
